export function createConfigContext (auth, price) {
  return {
    isCustomerList: price.CustomerId > 0,
    isShopList: price.CustomerId === 0 && price.ShopId > 0,
    isChainList: price.CustomerId === 0 && price.ShopId === 0 && price.ChainId > 0,
    isCustomerUser: auth.user.UserType === 4,
    isShopUser: auth.user.UserType === 5,
    isChainUser: auth.user.UserType === 2,
    isWorkProviderUser: auth.user.UserType === 6,
    isWorkProviderPM: price.WorkProviderId > 0,
    isSuperUser: auth.user.UserType === 1,
    department: price.Department,
    onlyShow: (auth.user.UserType === 1 || auth.user.UserType === 6) && price.UseRecommended
  }
}

export function getTaskPriceConfig (context) {
  return {
    itemIdField: 'TaskPriceId',
    itemOrderField: 'SortIndex',
    itemOrderLocked: 'SortIndexLocked',
    editable: !context.isCustomerUser && ((!context.isWorkProviderPM && !context.isWorkProviderUser) || (context.isWorkProviderPM && context.isWorkProviderUser)),
    whitebox: true,
    draggable: ((!context.isWorkProviderPM && !context.isWorkProviderUser) || (context.isWorkProviderPM && context.isWorkProviderUser)),
    title: 'No title',
    groupCss: 'partitem__list',
    itemCss: 'taskpriceItem',
    allowAdd: true,
    allowDelete: true,
    fields: [
      {
        name: 'TaskName',
        header: 1203,
        type: 'text',
        editable: false,
        hide: false,
        css: 'name',
        col: 3
      },
      {
        name: 'AE',
        header: 885,
        type: 'ae',
        editable: true,
        hide: false,
        css: ''
      },
      {
        name: 'Gross',
        header: 13350,
        type: 'currency',
        editable: false,
        hide: false,
        css: ''
      },
      {
        name: 'Discount',
        header: 15014,
        type: 'percent',
        editable: true,
        hide: false,
        css: ''
      },
      {
        name: 'Net',
        header: 1392,
        type: 'currency',
        editable: true,
        hide: false,
        css: ''
      },
      {
        name: 'Environment',
        header: 1044,
        type: 'currency',
        editable: false,
        hide: false,
        css: ''
      },
      {
        name: 'Total',
        header: 393,
        type: 'currency',
        editable: false,
        hide: false,
        css: ''
      }
    ],
    newItemInputs: ['TaskName', 'AE', 'Discount'],
    groupField: 'PartItemId'
  }
}

export function getServiceTaskConfig (context) {
  return {
    itemIdField: 'ServiceTaskId',
    itemOrderField: 'SortIndex',
    editable: !context.isCustomerUser && ((!context.isWorkProviderPM && !context.isWorkProviderUser) || (context.isWorkProviderPM && context.isWorkProviderUser)),
    whitebox: true,
    draggable: ((!context.isWorkProviderPM && !context.isWorkProviderUser) || (context.isWorkProviderPM && context.isWorkProviderUser)),
    title: 2224,
    allowAdd: true,
    allowDelete: true,
    // groupField: 'IsExtra',
    fields: [
      {
        name: 'Name',
        header: 1203,
        type: 'text',
        editable: false,
        hide: false,
        css: 'name'
      },
      {
        name: 'Price',
        header: 641,
        type: 'currency',
        editable: false,
        hide: false,
        css: ''
      },
      {
        name: 'Discount',
        header: 15014,
        type: 'percent',
        editable: true,
        hide: false,
        css: ''
      },
      {
        name: 'Net',
        header: 1305,
        type: 'currency',
        editable: true,
        hide: false,
        css: ''
      }
    ],
    newItemInputs: ['Name', 'Price', 'Discount', 'Net']
  }
}

export function getAddonStartTimeConfig (context) {
  return {
    itemIdField: 'AddonStartTimeId',
    itemOrderField: 'SortIndex',
    itemOrderLocked: 'SortIndexLocked',
    editable: !context.isCustomerUser && ((!context.isWorkProviderPM && !context.isWorkProviderUser) || (context.isWorkProviderPM && context.isWorkProviderUser)),
    whitebox: false,
    draggable: ((!context.isWorkProviderPM && !context.isWorkProviderUser) || (context.isWorkProviderPM && context.isWorkProviderUser)),
    title: null,
    headerHelp: 1962,
    groupCss: 'starttimes',
    allowAdd: true,
    allowDelete: true,
    fields: [
      {
        name: 'Name',
        header: 1195,
        type: 'text',
        editable: false,
        hide: false,
        css: 'name',
        col: 3
      },
      {
        name: 'AE',
        header: 885,
        type: 'ae',
        editable: true,
        hide: false,
        css: ''
      },
      {
        name: 'Mat',
        header: context.department !== 0 ? 14788 : 13443,
        type: 'currency',
        editable: true,
        hide: false,
        css: ''
      },
      {
        name: 'Price',
        header: 13350,
        type: 'currency',
        editable: false,
        hide: false,
        css: ''
      },
      {
        name: 'Discount',
        header: 15014,
        type: 'percent',
        editable: true,
        hide: false,
        css: 'discount'
      },
      {
        name: 'Net',
        header: 1305,
        type: 'currency',
        editable: true,
        hide: false,
        css: ''
      },
      {
        name: 'Env',
        header: 1044,
        type: 'currency',
        editable: false,
        hide: false,
        css: ''
      },
      {
        name: 'Total',
        header: 393,
        type: 'currency',
        editable: false,
        hide: false,
        css: ''
      }
    ],
    newItemInputs: ['Name', 'AE', 'Mat']
  }
}

export function getAddonPartConfig (context) {
  return {
    itemIdField: 'AddonPartId',
    itemOrderField: 'SortIndex',
    itemOrderLocked: 'SortIndexLocked',
    editable: !context.isCustomerUser && ((!context.isWorkProviderPM && !context.isWorkProviderUser) || (context.isWorkProviderPM && context.isWorkProviderUser)),
    whitebox: false,
    draggable: ((!context.isWorkProviderPM && !context.isWorkProviderUser) || (context.isWorkProviderPM && context.isWorkProviderUser)),
    title: null,
    groupCss: 'addonparts',
    allowAdd: true,
    allowDelete: true,
    fields: [
      {
        name: 'Name',
        header: 888,
        type: 'text',
        editable: false,
        hide: false,
        css: 'addonpart_name',
        col: 2
      },
      {
        name: 'AE',
        header: 15015,
        type: 'percent',
        editable: true,
        hide: false,
        css: 'addon_workUnits'
      },
      {
        name: 'Mat',
        header: 15016,
        type: 'percent',
        editable: true,
        hide: false,
        css: 'mat'
      },
      {
        name: 'StartTime',
        header: 1195,
        headerAppend: ' (%)',
        type: 'percent',
        editable: true,
        hide: context.department !== 0,
        css: 'starttime'
      }
    ],
    newItemInputs: ['Name', 'AE', 'Mat', 'StartTime']
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/PriceAgreements/Agreements/Details/config.js